import React from 'react';
import Skeleton from 'epn-ui/umd/dist/components/Skeleton';
import BaseEmpty from '@components/base/BaseEmpty';
import useI18n from '@i18n';

import { IGetCouponsDataFormatted } from '@api/types';
import BaseGrid from '@components/base/BaseGrid';
import Coupon from './Coupon';

export interface ICouponsProps {
    coupons: IGetCouponsDataFormatted[];
    isDataLoading: boolean;
    isReqHasError: boolean;
    onStoreClickHandler?: () => void;
    onCodeCopyHandler?: () => void;
}

const Coupons: React.FC<ICouponsProps> = ({
    coupons,
    isDataLoading,
    isReqHasError,
    onStoreClickHandler,
    onCodeCopyHandler,
}) => {
    const { t } = useI18n('Offers');

    return (
        <div>
            <BaseGrid container className="flex-wrap px-1 pb-3 gap-y-4">
                {coupons.map(coupon => (
                    <BaseGrid
                        key={coupon.id}
                        item
                        xl={4}
                        lg={6}
                        md={4}
                        xs={6}
                        initial={12}
                        className="px-0 xs:px-2"
                    >
                        <Coupon
                            url={coupon.url}
                            logo={coupon.logo}
                            endDate={coupon.dateTo}
                            promocode={coupon.promocode}
                            name={coupon.title}
                            description={coupon.description}
                            onStoreClickHandler={onStoreClickHandler}
                            onCodeCopyHandler={onCodeCopyHandler}
                        />
                    </BaseGrid>
                ))}
            </BaseGrid>
            <div className="flex flex-wrap gap-4">
                {[...new Array(6)].map((_, index) => (
                    <Skeleton
                        key={index}
                        loading={isDataLoading}
                        className="mb-8"
                        shape="square"
                        title={{
                            style: { width: '232px', height: '249px' },
                        }}
                    />
                ))}
            </div>

            {isReqHasError && <BaseEmpty message={t('Failed to load coupons')} />}
        </div>
    );
};

export default Coupons;
